export const FLIGHT_DATES_SESSION_STORAGE_KEY = "chfarFlightDates";
export const FLIGHT_ROUTE_SESSION_STORAGE_KEY = "chfarFlightRoute";
